import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling } from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import NameField from 'components/forms/new/formikFormFields/NameField';

const PlanComplexPortingFeeField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.complexPortingFee && touched.complexPortingFee}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()} >
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Complex Porting Fee
                </FormLabel>
                <Field
                    as={NameField}
                    id="complexPortingFee"
                    name="complexPortingFee"
                    data-walkthroughid={walkthroughIds.plans.ufComplexPortingFeeInput}
                    error={errors.complexPortingFee}
                    type="number"
                    step="any"
                />
                {isHovered && (
                    <FieldToolTip
                        label="Complex porting fee (if any)."
                        ariaLabel="plan-complex-porting-fee-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlanComplexPortingFeeField;
